import FirebaseDoc from "@/model/FirebaseDoc"

export default class Board extends FirebaseDoc {

}